import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import VcbPreviewApp from "./App.tsx";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <VcbPreviewApp />
  </React.StrictMode>
);
